import { Component, Inject } from '@angular/core';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { DialogService } from '../../../services/dialog.service';

@Component({
  selector: 'fieldmagic-manual-recaptcha-dialog',
  template: `
    <fieldmagic-dialog
      label="Please Verify"
      [instance]="self"
    >
      <ng-template fieldmagicDialogButtonsTmp></ng-template>

      <ng-template fieldmagicDialogContentTmp>
        <div
          class="d-flex justify-content-center align-items-center"
          style="height: 90px"
        >
          <re-captcha
            (resolved)="onComplete($event)"
          >
          </re-captcha>
        </div>
      </ng-template>
    </fieldmagic-dialog>
  `
})
export class ManualRecaptchaDialogComponent {
  get self(): ManualRecaptchaDialogComponent {
    return this;
  }

  constructor(
    private readonly _dialog: DialogService,
  ) {}

  onComplete(token: string): void {
    this._dialog.close({
      instance: this,
      result: token,
    });
  }
}